import { inject, Injectable } from '@angular/core';
import { ConfigService } from '@ps-gui/shared-core';
import { ClaimsTerminalConfig } from './config/ClaimsTerminalConfig';
import { CtBatch, CtBatchSource, isEingangCtBatch, isTaskCtBatch } from './model/ct-batch-model';
import { Navigate } from '@ps-gui/shared-utils';

/** Must name the place the user actually lands on - see PsNavigationService.navigateToOrigin */
export function backToOriginLabel(source: CtBatchSource): string {
  return source === CtBatchSource.LEGACY ? 'Zurück zu PROOF' : 'Zurück zum Dashboard';
}

@Injectable({
  providedIn: 'root',
})
export class PsNavigationService {
  private readonly configService = inject(ConfigService<ClaimsTerminalConfig>);

  navigateToOriginWithoutBack(ctBatch: CtBatch): void {
    if (ctBatch.source === CtBatchSource.LEGACY) {
      Navigate.replace(`${this.configService.config.auditUrl}/audit`);
      return;
    }

    Navigate.replace(this.dashboardOriginOf(ctBatch));
  }

  navigateToOrigin(ctBatch: CtBatch): void {
    if (ctBatch.source === CtBatchSource.LEGACY) {
      if (isTaskCtBatch(ctBatch)) {
        Navigate.assign(`${this.configService.config.digideskUrl}/task-list`);
      } else {
        Navigate.assign(`${this.configService.config.auditUrl}/audit`);
      }
      return;
    }

    Navigate.assign(this.dashboardOriginOf(ctBatch));
  }

  navigateToGutachten(gutachtenAuftragId: string) {
    Navigate.assign(this.buildGutachtenDetailsPageUrl(gutachtenAuftragId));
  }

  openGutachten(gutachtenAuftragId: string) {
    Navigate.open(this.buildGutachtenDetailsPageUrl(gutachtenAuftragId));
  }

  private buildGutachtenDetailsPageUrl(gutachtenAuftragId: string) {
    return `${this.configService.config.dashboardUrl}/gutachten/v2/${gutachtenAuftragId}`;
  }

  private dashboardOriginOf(ctBatch: CtBatch): string {
    const dashboardUrl = this.configService.config.dashboardUrl;

    return isEingangCtBatch(ctBatch) ? `${dashboardUrl}/eingaenge` : dashboardUrl;
  }

  navigateToDigideskTaskList() {
    Navigate.assign(`${this.configService.config.digideskUrl}/task-list`);
  }

  navigateToDigideskEse(eseId: string) {
    Navigate.assign(`${this.configService.config.digideskUrl}/ese/${eseId}`);
  }
}
